var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AnalyticsSubPage,{attrs:{"title":"Loans Analytics","icon":"hand-holding-dollar","css-class":"analytics-loans","default-label":"Loans"}},[_c(_setup.SdlMetrics)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }